import { useTranslation } from "react-i18next";
import { SupportedLocale } from "../../i18n";
import "./styles.css";

type Props = { compact?: boolean; className?: string };

export function LanguageSelector({ compact = false, className = "" }: Props) {
  const { i18n, t } = useTranslation();
  const active: SupportedLocale = i18n.language.startsWith("es") ? "es" : "pt-BR";
  const change = (locale: SupportedLocale) => void i18n.changeLanguage(locale);

  return (
    <div className={`language-selector ${compact ? "language-selector--compact" : ""} ${className}`} role="group" aria-label={t("language.label")}>
      <button type="button" className={active === "pt-BR" ? "active" : ""} aria-pressed={active === "pt-BR"} title={t("language.portuguese")} onClick={() => change("pt-BR")}>PT</button>
      <span aria-hidden="true">|</span>
      <button type="button" className={active === "es" ? "active" : ""} aria-pressed={active === "es"} title={t("language.spanish")} onClick={() => change("es")}>ES</button>
    </div>
  );
}
